import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SignupPopup from "./SignupPopup";
import OtpVerify from "./OtpVerify";
import ResumeUpload from "./ResumeUpload";
import { Avatar, useMediaQuery, Fade } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import Cookies from "js-cookie";
import { useGetprofileapiQuery } from "../Store/Middleware/api/getProfileAPI";

const Header = () => {
  const isSmallScreen = useMediaQuery("(max-width: 625px)");
  const nav = useNavigate();
  const location = useLocation();

  // ✅ BUG 1 FIX: Page load/refresh par check karo
  // agar pendingAuthToken hai toh ResumeUpload popup
  // automatically open hona chahiye
  const hasPendingToken = !!localStorage.getItem("pendingAuthToken");

  const [isOpen, setIsOpen] = useState({
    isSignupOpen: false,
    isOTPOpen: false,
    // ✅ pendingAuthToken hai toh isResumeOpen true se initialize karo
    isResumeOpen: hasPendingToken,
    isAvatarOpen: false,
    hamburgerMenuOpen: false,
  });

  const [token, setToken] = useState("");

  const isLoggedIn = Cookies.get("authToken");

  const { data: profileData } = useGetprofileapiQuery(undefined, {
    skip: !isLoggedIn,
  });

  const profilePicUrl =
    profileData?.message?.details?.profile_path?.replace(
      "profilePicture",
      "profile",
    ) || "";

  const handleLogout = () => {
    localStorage.clear();
    Cookies.remove("authToken");
    window.location.href = "/";
  };

  const handleNav = (path) => {
    nav(path);
    setIsOpen((prev) => ({
      ...prev,
      hamburgerMenuOpen: false,
      isAvatarOpen: false,
    }));
  };

  const isAuthPage = window?.location?.pathname?.split("/")[1] === "authPage";

  const renderUserMenu = () => (
    <div className="dropdown">
      <div
        role="button"
        id="dropdownMenuLink"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        className="align-items-center d-flex justify-content-lg-end"
        style={{ textDecoration: "none", color: "black" }}
      >
        <Avatar
          src={profilePicUrl}
          sx={{ cursor: "pointer", height: "35px", width: "35px" }}
          onClick={() =>
            setIsOpen((prev) => ({
              ...prev,
              isAvatarOpen: !prev.isAvatarOpen,
            }))
          }
        />
      </div>

      <ul
        className={`dropdown-menu showRight shadow-lg ul-dropdown ${
          isOpen.isAvatarOpen ? "show" : ""
        }`}
        style={{ zIndex: "2" }}
        aria-labelledby="dropdownMenuLink"
      >
        <li>
          <span
            className="dropdown-item"
            style={{ cursor: "pointer", fontWeight: "600" }}
            onClick={() => handleNav("/authPage/profileSection")}
          >
            My Profile
          </span>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>
        <li>
          <span
            className="dropdown-item"
            style={{ cursor: "pointer", fontWeight: "600" }}
            onClick={() => handleNav("/authPage/jobdetails/appliedJob")}
          >
            Applied Jobs
          </span>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>
        <li>
          <span
            className="dropdown-item logouthover"
            style={{ cursor: "pointer", fontWeight: "600" }}
            onClick={handleLogout}
          >
            Logout
          </span>
        </li>
      </ul>
    </div>
  );

  const renderLoginButton = () => (
    <button
      className={
        isOpen.isSignupOpen
          ? "job-btn-active"
          : location?.pathname?.includes("jobdetails")
            ? "login-btn-primary"
            : "job-btn-active"
      }
      onClick={() =>
        setIsOpen((prev) => ({
          ...prev,
          isSignupOpen: !prev.isSignupOpen,
          hamburgerMenuOpen: false,
        }))
      }
    >
      Login
    </button>
  );

  const renderMenuItems = () => (
    <>
      <div
        className={`jobsFont ${
          location?.pathname?.includes("jobdetails") ? "job-btn-active" : ""
        }`}
        onClick={() => handleNav("/authPage/jobdetails/openposition")}
      >
        Jobs
      </div>
      <div>
        {isAuthPage && isLoggedIn ? renderUserMenu() : renderLoginButton()}
      </div>
    </>
  );

  return (
    <>
      {!isSmallScreen ? (
        <section className="headerSection">
          <div className="headerSeperate">
            <Link to={isLoggedIn ? "/authPage/jobdetails/openposition" : "/"}>
              <img
                src="/Spanidea--768x134.png"
                alt="Spanidea Logo"
                className="spanIdeaLogo"
              />
            </Link>
            <div style={{ display: "flex", gap: "50px", alignItems: "center" }}>
              {renderMenuItems()}
            </div>
          </div>
        </section>
      ) : (
        <section className="headerSection">
          <div className="mobile-header-m1">
            <Link to="/">
              <img
                src="/Spanidea--768x134.png"
                alt="Spanidea Logo"
                className="spanIdeaLogo"
              />
            </Link>
            {isOpen.hamburgerMenuOpen ? (
              <CloseIcon
                fontSize="large"
                style={{ color: "white" }}
                onClick={() =>
                  setIsOpen((prev) => ({
                    ...prev,
                    hamburgerMenuOpen: false,
                  }))
                }
              />
            ) : (
              <MenuIcon
                fontSize="large"
                style={{ color: "white" }}
                onClick={() =>
                  setIsOpen((prev) => ({
                    ...prev,
                    hamburgerMenuOpen: true,
                  }))
                }
              />
            )}
          </div>

          {isOpen.hamburgerMenuOpen && (
            <Fade
              in={isOpen.hamburgerMenuOpen}
              style={{ transformOrigin: "0 0 0" }}
              timeout={500}
            >
              <div className="mobile-header-m2">{renderMenuItems()}</div>
            </Fade>
          )}
        </section>
      )}

      {isOpen.isSignupOpen && (
        <SignupPopup isOpen={isOpen} setIsOpen={setIsOpen} />
      )}
      {isOpen.isOTPOpen && (
        <OtpVerify isOpen={isOpen} setIsOpen={setIsOpen} setToken={setToken} />
      )}
      {/* ✅ BUG 1 FIX: hasPendingToken || isOpen.isResumeOpen dono cases handle */}
      {(isOpen.isResumeOpen || hasPendingToken) && (
        <ResumeUpload isOpen={isOpen} setIsOpen={setIsOpen} token={token} />
      )}
    </>
  );
};

export default Header;
